/**
 * cizilecekStandService.js — the stands of a hall that have NO drawing yet (backlog #655, #658; backend #654).
 *
 *   GET /api/v2/vector/fuar/{fuarId}/stands-to-draw?salonId=   (staff only; outside /api/v1, so JAVA_BACKEND_ORIGIN)
 *     -> { total, lastPlanSaveAt, stands: [{ standId, standName, salonId, firmaId, firmaName, firmaShortName,
 *                                             areaM2, standDimensions, height }] }, natural-sorted by name.
 *
 * "To be drawn" = a live stand placed in the hall at the fair with no row in stand_vector_shape for that fair. The mirror
 * is written by fdsVector's save, so it can LAG the editor by seconds: the screens show lastPlanSaveAt and offer a refresh.
 * The per-hall COUNTS are on GET /fuar/{fuarId}/h-max (standCount, drawnStandCount, toDrawCount) — see Components/FairAreas/cizilecek.jsx.
 *
 * Never throws: `ok:false` means "could not ask" (403 for a non-staff login, network, an older backend without the endpoint), which
 * is NOT the same as "nothing to draw".
 */
import axios from 'axios';
import { JAVA_BACKEND_ORIGIN, getAuthHeader } from '../Components/Contexts/BackendConstants';

const VECTOR = `${JAVA_BACKEND_ORIGIN}/api/v2/vector`;

/**
 * @returns {Promise<{ok: boolean, total: number, lastPlanSaveAt: string|null, stands: Array<object>, message?: string}>}
 */
export async function getCizilecekStandlar(fuarId, salonId) {
  if (fuarId == null || !/^\d+$/.test(String(fuarId))) return { ok: false, total: 0, lastPlanSaveAt: null, stands: [], message: 'no numeric fuarId' };
  const query = salonId != null && /^\d+$/.test(String(salonId)) ? `?salonId=${salonId}` : '';
  try {
    const res = await axios.get(`${VECTOR}/fuar/${fuarId}/stands-to-draw${query}`, { headers: getAuthHeader() });
    const data = res.data ?? {};
    const stands = Array.isArray(data.stands) ? data.stands : [];
    return { ok: true, total: Number.isFinite(Number(data.total)) ? Number(data.total) : stands.length, lastPlanSaveAt: data.lastPlanSaveAt ?? null, stands };
  } catch (e) {
    return { ok: false, total: 0, lastPlanSaveAt: null, stands: [], message: e?.response?.status ? `HTTP ${e.response.status}` : String(e?.message || e) };
  }
}

/** The ids of the stands in a to-draw list, as text (a stand row of the roster is drawn when its id is NOT in this set). */
export function cizilecekIdKumesi(stands) {
  return new Set((stands || []).map((s) => String(s.standId)));
}
